// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-components-post-layout-js": () => import("/opt/build/repo/src/components/post-layout.js" /* webpackChunkName: "component---src-components-post-layout-js" */),
  "component---src-components-tags-layout-js": () => import("/opt/build/repo/src/components/tags-layout.js" /* webpackChunkName: "component---src-components-tags-layout-js" */),
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("/opt/build/repo/src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

